import { render, staticRenderFns } from "./RescheduleBooking.vue?vue&type=template&id=2b333c48&scoped=true&"
import script from "./RescheduleBooking.vue?vue&type=script&lang=ts&"
export * from "./RescheduleBooking.vue?vue&type=script&lang=ts&"
import style0 from "./RescheduleBooking.vue?vue&type=style&index=0&id=2b333c48&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b333c48",
  null
  
)

export default component.exports